import React from "react";
import { required, InputField } from "modules/4_final_form/web";

import { FormGroup, Label, Row, Col, Button } from "reactstrap";

import { Field } from "react-final-form";

export default class ProjectVariationNumberForm extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { handleSubmit, formLabel, cancelFunction } = this.props;

    return (
      <form>
        <FormGroup row>
          <Label md={2}>Number</Label>
          <Col md={4}>
            <Field component={InputField} name="number" type="number" validate={required} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>Description</Label>
          <Col md={4}>
            <Field component={InputField} name="description" parse={(value) => value} validate={required} />
          </Col>
        </FormGroup>

        <Row>
          <Col>
            <Button color="success" onClick={handleSubmit}>
              {formLabel} Variation numbers
            </Button>
          </Col>
          <Col className="text-right">
            <Button onClick={cancelFunction} className="float-right" color="danger">
              Cancel
            </Button>
          </Col>
        </Row>
      </form>
    );
  }
}
